import { type IImage } from "@/types"
import { API_URL_STORAGE } from "@/api/urls"

const replaceUrl = (value: string) =>
  value ? `${API_URL_STORAGE}${value[0] !== "/" ? "/" : ""}${value}` : ""

export const getImage = (image: IImage | string | null) => {
  if (!image) return ""
  if (typeof image === "string") return replaceUrl(image)
  const { url } = image ?? {}

  return replaceUrl(url)
}
